export default "__VITE_ASSET__df370c6b__"